import { render } from "./StarsOrderLine.vue?vue&type=template&id=af8c576e&scoped=true"
import script from "./StarsOrderLine.vue?vue&type=script&lang=js"
export * from "./StarsOrderLine.vue?vue&type=script&lang=js"

import "./StarsOrderLine.vue?vue&type=style&index=0&id=af8c576e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8c576e"]])

export default __exports__